export const SET_HOTELS = 'SET_HOTELS';
